import React from "react";
import { ApolloClient, InMemoryCache, ApolloProvider, HttpLink } from "@apollo/client";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "./components/context/AuthContext";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { getApiBaseUrl } from "./config/runtime";

const apiBaseUrl = getApiBaseUrl();

const httpLink = new HttpLink({
  uri: `${apiBaseUrl}/graphql`,
  credentials: "include",
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

console.log("Apollo API base URL:", apiBaseUrl);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ApolloProvider>
  </React.StrictMode>
);

reportWebVitals();
